export interface StatusSCEPlugin {
  id: string;
  registered: boolean;
  ready: boolean;
  paired: boolean;
  paired_app_name: string;
  paired_app_id: string;
  connecting: boolean;
  connected: boolean;
  reader_connected: boolean;
  debug : boolean
}
